export enum InputType {
  Input = "input",
  Dropdown = "dropdown",
  Checkbox = "checkbox",
  Textarea = "textarea",
}

export enum InputLabel {
  Email = "E-Mail address",
  Phone = "Contact phone number",
  CompanyName = "Company name",
  EstimatedFrequency = "Estimated frequency of orders",
  EstimatedVolume = "Estimated volume of a single order",
  FamilyName = "Family Name",
  FirstName = "First Name",
  Job = "Job title",
  Website = "Website address",
}

export interface CustomFormField {
  id: string
  label: InputLabel
  required: boolean
  type: InputType
  options?: { label: string; value: string }[]
}

export interface CustomFormConfig {
  form: {
    targetEmail?: string
    id?: string
    fields: CustomFormField[]
  }
}

export interface CustomFormProps {
  config: CustomFormConfig
}
